import React from "react";
import {
  FaCheckCircle,
  FaShieldAlt,
  FaHandshake,
  FaHome,
} from "react-icons/fa";
import "./SaiBhavanaRealty.css";

const sections = [
  {
    icon: <FaShieldAlt />,
    title: "100% Legal & Verified Properties",
    items: [
      "Clear ownership & marketable title",
      "Approved layouts and building permissions",
      "DTCP / local authority approvals",
      "No legal disputes or hidden liabilities",
    ],
  },
  {
    icon: <FaHandshake />,
    title: "Built on Trust & Transparency",
    items: [
      "No hidden charges",
      "Complete documentation support",
      "Transparent pricing",
      "Honest guidance at every stage",
    ],
  },
  {
    icon: <FaHome />,
    title: "Our Services",
    items: [
      "Residential Plots & Open Lands",
      "Apartments & Flats",
      "Independent Houses",
      "Commercial Properties",
      "Property Buying & Selling Assistance",
      "Documentation & Registration Support",
    ],
  },
  {
    icon: <FaCheckCircle />,
    title: "Our Promise",
    items: [
      "Genuine Properties",
      "Legal Security",
      "Professional Service",
      "Customer Satisfaction",
    ],
  },
];

const SaiBhavanaRealty = () => {
  return (
    <div className="modern-container">

      {/* Decorative Shapes */}
      <div className="shape shape1"></div>
      <div className="shape shape2"></div>

      <div className="intro-section">
        <h1>
          Sai Bhavana Realty – Puttaparthi’s Trusted Real Estate Partner
        </h1>
        <p>
          We specialize in legally verified plots, lands, flats, and houses in
          Puttaparthi to Banglore. Clear titles, transparent pricing, and
          complete documentation support.
        </p>
      </div>

      <div className="card-grid">
        {sections.map((section, index) => (
          <div key={index} className="modern-card">
            <div className="card-icon">{section.icon}</div>
            <h3>{section.title}</h3>
            <ul>
              {section.items.map((item, i) => (
                <li key={i}>
                  <FaCheckCircle className="tick-icon" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SaiBhavanaRealty;